interface BaseStatus {
  name: string;
  textColor?: string;
  backgroundColor?: string;
}

const PROCESS_STATUS: Record<string, BaseStatus> = {
  pending: {
    name: "PENDING",
    textColor: "gray.900",
    backgroundColor: "gray.200",
  },
  completed: {
    name: "COMPLETED",
    textColor: "blue.900",
    backgroundColor: "blue.100",
  },
  failed: {
    name: "FAILED",
    textColor: "red.900",
    backgroundColor: "red.100",
  },
  in_progress: {
    name: "IN PROGRESS",
    textColor: "yellow.900",
    backgroundColor: "yellow.100",
  },
};

const PAYMENT_STATUS: Record<string, BaseStatus> = {
  paid: {
    name: "PAID",
    textColor: "green.900",
    backgroundColor: "green.100",
  },
  open: {
    name: "OPEN",
    textColor: "purple.900",
    backgroundColor: "purple.100",
  },
};

export { PROCESS_STATUS, PAYMENT_STATUS };
export type { BaseStatus };
